import { render, staticRenderFns } from "./PlusProductBase.vue?vue&type=template&id=966c2f8c&scoped=true"
import script from "./PlusProductBase.vue?vue&type=script&lang=ts"
export * from "./PlusProductBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966c2f8c",
  null
  
)

export default component.exports